// extracted by mini-css-extract-plugin
export default {"container":"BusinessSolution_container__Hq8uu"};